module.exports = __webpack_public_path__ + "static/media/voice-channel-logo.946ceb35.svg";